/** @jsxImportSource theme-ui */
import { format } from 'date-fns';
import { useGetVossSubscriptionsDiscountsQuery } from '@/store/apiService';
import DataTable from '@/components/DataTable';

const columns = [
    {
        Header: 'Status',
        id: 'status',
        accessor: 'status',
    },
    {
        Header: 'Discount agreement id',
        id: 'discountAgreementId',
        accessor: 'discountAgreementId',
    },
    {
        Header: 'Version id',
        id: 'versionId',
        accessor: 'versionId',
    },
    {
        Header: 'Name',
        id: 'name',
        accessor: 'name',
    },
    {
        Header: 'Start date',
        id: 'startDate',
        accessor: 'startDate',
        Cell: ({ cell }) => format(new Date(cell.value), 'd MMM yyyy, p'),
    },
    {
        Header: 'End date',
        id: 'endDate',
        accessor: 'endDate',
        Cell: ({ cell }) => format(new Date(cell.value), 'd MMM yyyy, p'),
    },
];

const SubscriptionDiscounts: React.FC<{ id: string }> = ({ id }) => {
    const subscriptionsDiscounts = useGetVossSubscriptionsDiscountsQuery({
        id,
    });

    return (
        <DataTable
            data={subscriptionsDiscounts.data}
            columns={columns}
            isLoading={subscriptionsDiscounts.isLoading}
            isFetching={subscriptionsDiscounts.isFetching}
            sortBy={[{ id: 'status', asc: true }]}
        />
    );
};

export default SubscriptionDiscounts;
